import { render, staticRenderFns } from "./AwardPopup.vue?vue&type=template&id=4472ecbe"
import script from "./AwardPopup.vue?vue&type=script&lang=js"
export * from "./AwardPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports